import React from "react";
import styled from "styled-components";
import { FontFamily, content } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import { tr } from "@radarly/i18n";

interface IProps {
  locale: Locale;
}

const Inner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  font-family: ${FontFamily.Sans};
  > h3 {
    color: ${(props) => content(props, "secondary")};
  }
`;

export default function ErrorCardInnerLayout({ locale }: IProps) {
  return (
    <Inner>
      <h3>{tr(locale, "INSIGHT-PAGES::ERROR-GLOBAL")}</h3>
    </Inner>
  );
}
